import { render, staticRenderFns } from "./SiteFooter.vue?vue&type=template&id=5e02b298&scoped=true"
import script from "./SiteFooter.vue?vue&type=script&lang=js"
export * from "./SiteFooter.vue?vue&type=script&lang=js"
import style0 from "./SiteFooter.vue?vue&type=style&index=0&id=5e02b298&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e02b298",
  null
  
)

export default component.exports